import Settings from 'src/Settings';
import DefaultDescriptor from './discountCode-default';
import AramarkDescriptor from './discountCode-aramark';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: DefaultDescriptor,
  [BuildTypeEnum.default]: DefaultDescriptor,
  [BuildTypeEnum.companykitchen]: DefaultDescriptor,
  [BuildTypeEnum.refive]: DefaultDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
